import { useRouter } from "next/router";
import { useMemo } from "react";
import type { FunctionComponent } from "react";

import { ClientSideSuspense } from "shared/components/common/client-side-suspense";
import { isString, parseQueryString } from "shared/lib/utils";

import { Portal } from "scmp-app/components/common/portal";
import { AgendaFilter } from "scmp-app/components/plus/news-agenda/filter";
import { PlusNewsAgendaItem } from "scmp-app/components/plus/news-agenda/item";

import Calendar from "./calendar-days.svg";
import { PlusAgendaPageListElementId } from "./const";
import {
  Container,
  EmptyList,
  EmptyListSubtitle,
  EmptyListTitle,
  Filter,
  List,
  StyledLoading,
  Title,
} from "./styles";

export const PlusNewsAgendaLeft: FunctionComponent = () => {
  const { query } = useRouter();

  const preset = useMemo(() => {
    const entityId = parseQueryString(query.entityId);
    const startDate = parseQueryString(query.startDate);

    if (startDate && isString(startDate)) {
      return {
        entityId,
        startDate: new Date(Number.parseInt(startDate)),
      };
    }
    return {};
  }, [query]);

  return (
    <Container>
      <Title>NEWS AGENDA</Title>
      <Filter>
        <ClientSideSuspense>
          <AgendaFilter entityId={preset?.entityId} startDate={preset?.startDate}>
            {({ hasNextPage, infiniteScrollTriggerReference, topics }) => (
              <Portal replace selector={`#${PlusAgendaPageListElementId}`}>
                {topics.length === 0 ? (
                  <EmptyList>
                    <Calendar />
                    <EmptyListTitle>
                      Oops, it looks like there are no entries for this period.
                    </EmptyListTitle>
                    <EmptyListSubtitle>Try adjusting your date filters</EmptyListSubtitle>
                  </EmptyList>
                ) : (
                  <List>
                    {topics.map(({ node }, index) => (
                      <PlusNewsAgendaItem key={index} reference={node} />
                    ))}
                    {hasNextPage && (
                      <StyledLoading ref={element => infiniteScrollTriggerReference(element)} />
                    )}
                  </List>
                )}
              </Portal>
            )}
          </AgendaFilter>
        </ClientSideSuspense>
      </Filter>
      <div id={PlusAgendaPageListElementId} />
    </Container>
  );
};

PlusNewsAgendaLeft.displayName = "PlusNewsAgendaLeft";
